/**
 * Nette/NAIS flash types → PNotify 3 types.
 * PNotify only knows notice|info|success|error (notice = Bootstrap alert-warning).
 */
function mapFlashTypeToPNotify(type: string): string {
    switch (type) {
        case 'warning':
            return 'notice';
        case 'danger':
            return 'error';
        case 'notice':
        case 'info':
        case 'success':
        case 'error':
            return type;
        default:
            return 'info';
    }
}

export function throwPNotify(message: string, type: string, _elementName?: string): void {
    if (typeof window.PNotify !== 'function' || !window.PNotify.prototype?.options) {
        return;
    }

    // Ensure stack targets a live body — PNotify may capture $("body") before <body> exists.
    const stack = window.PNotify.prototype.options.stack as { context?: { length?: number } } | undefined;
    if (stack && !(stack.context && stack.context.length) && window.jQuery) {
        stack.context = window.jQuery(document.body);
    }

    const notice = new window.PNotify({
        animation: 'fade',
        text: message,
        delay: 7000,
        mouse_reset: true,
        type: mapFlashTypeToPNotify(type),
        styling: 'bootstrap5',
        buttons: { closer: true, sticker: false },
    });
    notice.get().on('click', () => notice.remove());
}

let flashInitScheduled = false;

/** Flashes rendered as data attributes in @layoutAdmin (avoids inline scripts). */
export function initLayoutFlashes(): void {
    if (flashInitScheduled) {
        return;
    }
    flashInitScheduled = true;

    // Defer until after PNotify's own jQuery.ready has bound stack.context to <body>.
    window.setTimeout(() => {
        flashInitScheduled = false;
        const seen = new Set<string>();
        document.querySelectorAll<HTMLElement>('[data-nais-flash], [data-nais-flash-meta]').forEach((el) => {
            const message = (el.getAttribute('data-message') ?? '').trim();
            const type = (el.getAttribute('data-type') ?? 'info').trim() || 'info';
            const key = `${type}\0${message}`;
            if (message !== '' && !seen.has(key)) {
                seen.add(key);
                throwPNotify(message, type);
            }
            el.remove();
        });
    }, 0);
}

window.throwPNotify = throwPNotify;
